import React from 'react';

const { __, getLocaleData } = window.wp.i18n;

class JobSingleShowMoreButton extends React.Component {
  render() {
    return (
      <div className="content-more">
        <a href={"/job-search"} className="more2">{ __( 'Show more positions', 'macs-react-jobs' ) }</a>
      </div>
    )
  }
}

export default JobSingleShowMoreButton;
